<template>
    <section class="LandingPage ContentSection" :style="{ 'background-color': pageData.color }">
        <div class="LandingPage__wheel" ref="wheelwrapper" :class="{'LandingPage__wheel--animating': wheelAnimating}" @mousedown="wheelAnimating = false" @mouseout="wheelAnimating = true" @touchstart="wheelAnimating = false" @touchend="wheelAnimating = true">
            <div>
                <img src="@/assets/img/ui/frontpage-wheel.svg" :style="{transform: `rotate(${rotation}deg)`}" ref="wheel">
            </div>
        </div>

        <aside>
            <img src="@/assets/img/ui/logo.png">
            <h1 v-html="properties.title"></h1>
            <div v-html="properties.subtitle"></div>

            <router-link :to="getRouteFromID(properties.sceneLink)" class="Button">Start</router-link>
        </aside>
    </section>
</template>
<script>
export default {
    props: ["properties", "pageData"],
    data() {
        return {
            rotation: 0,
            wheelAnimating: true
        }
    },
    mounted() {
        this.initHammer();
    },
    methods: {
        initHammer() {
            const wheelwrapper = this.$refs.wheelwrapper;
            var mc = new Hammer(wheelwrapper);
            var t = this;

            let velocity = 0
            let spin = {};
            let temprotation = t.rotation;

            mc.on('panstart', (e) => {
                temprotation = t.rotation;
            })
            mc.on('pan', (e) => {
                velocity = -e.velocityX
                t.rotation = parseInt(temprotation + (-e.deltaX * 0.2))
            })
            mc.on('panend', (e) => {
                spin = (time) => {
                    t.rotation += velocity
                    velocity *= 0.98
                    if (Math.abs(velocity) > 0.01) {
                        requestAnimationFrame(spin)
                    }
                }
                requestAnimationFrame(spin)
            })
        },
        getRouteFromID(id) {
            return app.manifest.getRouteFromID(id);
        }
    }
}
</script>
<style lang="scss">
.LandingPage {
    position: relative;
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;

    .LandingPage__wheel {
        position: absolute;
        transform: translateY(-52%);

        &>div {
            &>img {
                pointer-events: none;
                max-width: 90vw;
                transform: rotate(0deg);
            }
        }
        
        &--animating {
            &>div {
                animation-name: rotateWheel;
                animation-duration: 200s;
                animation-timing-function: linear;
                animation-fill-mode: forwards;
                animation-iteration-count: infinite;
            }
        }
    }

    >aside {
        position: absolute;
        // left: 50%;
        top: 57%;
        // transform: translateX(-50%) translateY(-50%);
        transform:  translateY(-50%);
        padding:0 40px;
        color: #fff;
        display: flex;
        align-items: center;
        flex-direction: column;

        img {
            width: 175px;
        }

        h1 {
            position: relative;
            margin-bottom: 75px;

            &::after {
                content: '';
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                top: calc(100% + 30px);
                height: 6px;
                width: 80px;
                background-color: var(--secondary-color);
            }
        }

        p {
            margin-bottom: 20px;
            padding: 0;

            &:last-of-type {
                margin-bottom: 55px;
            }
        }

        a.Button {
            background: #fff;
            color: #000;
        }
    }
}

@keyframes rotateWheel {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }

}
</style>*